// extracted by mini-css-extract-plugin
export default {"heading":"DefaultBid_heading__CQkCl","wrapper":"DefaultBid_wrapper__inetC","suggestionText":"DefaultBid_suggestionText__Jjbc5","pandaImg":"DefaultBid_pandaImg__4aMAj"};